export default __webpack_public_path__ + "static/media/Overall_Plant.838e11f7.jpg";